import * as z from "zod";

/**
 * Id + name only, for pickers. The full signup form/spotlight documents are far
 * too heavy to load just to render a dropdown.
 */
export const getSignupFormOptionsMinimal = {
  name: "getSignupFormOptionsMinimal" as const,
  input: z.object({}),
  output: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      source: z.enum(["signup_form", "spotlight"]),
    }),
  ),
};
